import { ReactElement, ReactNode } from 'react'

export interface CircleContainerProps {
  children?: ReactNode
  color?: string
  size?: number
}

export default function CircleContainer(props: CircleContainerProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        width: 'auto',
        minWidth: props.size ?? '24px',
        height: '100%',
        letterSpacing: 0,
        lineHeight: undefined,
        aspectRatio: '1/1',
        borderRadius: '50%',
        backgroundColor: props.color
      }}
    >
      {props.children}
    </div>
  )
}
